<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/reveal.js/3.8.0/css/theme/moon.css"
  id="theme"
/>

<div class="reveal">
  <div class="slides">
    <section data-markdown="/assets/test.md" data-separator="^---"></section>
  </div>
</div>

<!-- <div class="reveal"> -->
<!-- <div class="slides"> -->
<!-- <section>Slide 1</section> -->
<!-- <section>Slide 2</section> -->
<!-- </div> -->
<!-- </div> -->
